import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=479df4e0&scoped=true&lang=pug"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"
import style0 from "./Page.vue?vue&type=style&index=0&id=479df4e0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479df4e0",
  null
  
)

export default component.exports